import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Show, useClerk } from "@clerk/react";
import { CONTENT } from "@/content";
import { useMe } from "@/lib/api";

const slug = (to) => (to === "/" ? "home" : to.slice(1));

const Item = ({ to, label, close }) => (
  <NavLink to={to} end className="nav-link" onClick={close} data-testid={`nav-${slug(to)}`}>{label}</NavLink>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { isAdmin } = useMe();
  const { signOut } = useClerk();
  const close = () => setOpen(false);
  const A = CONTENT.authNav;
  return (
    <div className="shell-top" data-testid="site-header">
      <p className="sticky-line" data-testid="sticky-top-line">{CONTENT.stickyTop}</p>
      <header className="nb-bar header-bar">
        <Link to="/" className="site-name" data-testid="site-name-link" onClick={close}>
          <img src="/icon.png" alt={CONTENT.logoAlt} className="site-logo" data-testid="site-logo" />
          <span>{CONTENT.siteName}</span>
        </Link>
        <button className="menu-btn" onClick={() => setOpen(!open)} aria-expanded={open} data-testid="mobile-menu-button">
          {open ? CONTENT.closeMenuLabel : CONTENT.menuLabel}
        </button>
        <nav className={`nav ${open ? "nav-open" : ""}`} data-testid="main-nav">
          {CONTENT.nav.map((item) => <Item key={item.to} {...item} close={close} />)}
          <Show when="signed-out"><Item {...A.login} close={close} /></Show>
          <Show when="signed-in">
            <Item {...A.myShares} close={close} />
            {isAdmin && <Item {...A.admin} close={close} />}
            <button className="nav-link nav-btn" onClick={() => { close(); signOut({ redirectUrl: "/" }); }} data-testid="nav-logout">{A.logout}</button>
          </Show>
        </nav>
      </header>
    </div>
  );
};
